const codigoContrato = parseInt(sessionStorage.getItem('codigoContrato') ?? localStorage.getItem('codigoContrato') ?? 'NaN');
const codigoEscola = parseInt(sessionStorage.getItem('codigoEscola') ?? localStorage.getItem('codigoEscola') ?? 'NaN');
const codigoGrupo = parseInt(sessionStorage.getItem('codigoGrupo') ?? localStorage.getItem('codigoGrupo') ?? 'NaN');
const codigoProfessor = parseInt(sessionStorage.getItem('codigoProfessor') ?? localStorage.getItem('codigoProfessor') ?? 'NaN');
const codigoResponsavel = parseInt(sessionStorage.getItem('codigoResponsavel') ?? localStorage.getItem('codigoResponsavel') ?? 'NaN');
const codigoAluno = parseInt(sessionStorage.getItem('codigoAluno') ?? localStorage.getItem('codigoAluno') ?? 'NaN');
const codigoUsuario = parseInt(sessionStorage.getItem('codigoUsuario') ?? localStorage.getItem('codigoUsuario') ?? 'NaN');
const ano = parseInt(sessionStorage.getItem('ano') ?? localStorage.getItem('ano') ?? 'NaN');
const semestre = parseInt(sessionStorage.getItem('semestre') ?? localStorage.getItem('semestre') ?? 'NaN');
const readOnly = parseInt(sessionStorage.getItem('readOnly') ?? localStorage.getItem('readOnly') ?? 'NaN');
const chamadaViaProxy = sessionStorage.getItem('chamadaViaProxy') ?? localStorage.getItem('chamadaViaProxy');
const codigoEnsino = parseInt(sessionStorage.getItem('codigoEnsino') ?? localStorage.getItem('codigoEnsino') ?? 'NaN');
export type State = {
  codigoContrato: number;
  codigoEscola: number;
  codigoGrupo: number;
  codigoProfessor: number;
  codigoResponsavel: number;
  codigoAluno: number;
  codigoUsuario: number;
  ano: number;
  semestre: number;
  readOnly: number;
  chamadaViaProxy: boolean;
  codigoEnsino: number;
}

export const state: State = {
  codigoContrato: codigoContrato,
  codigoEscola: codigoEscola,
  codigoGrupo: codigoGrupo,
  codigoProfessor: codigoProfessor,
  codigoResponsavel: codigoResponsavel,
  codigoAluno: codigoAluno,
  codigoUsuario: codigoUsuario,
  ano: ano,
  semestre: semestre,
  readOnly: readOnly,
  chamadaViaProxy: chamadaViaProxy === "1",
  codigoEnsino: codigoEnsino,
};
